import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class ProductSubtypeIndicatorData implements IIndicatorData {
  private readonly name: string = "ProductSubType";

  constructor(private readonly items: IndicatorData[]) {}

  getName(): string {
    return this.name;
  }

  getProductSubTypeTotal(): string {
    return this.items[0].getValue() as string;
  }

  getGenericQuantity(): number {
    const genericQuantityIndicatorData = this.items[1].getValue()[0] as IndicatorData;
    return Number(genericQuantityIndicatorData.getValue());
  }

  getGenericPercentage(): number {
    const genericPercentageIndicatorData = this.items[1].getValue()[1] as IndicatorData;
    return Number(genericPercentageIndicatorData.getValue());
  }

  getSimilarQuantity(): number {
    const genericQuantityIndicatorData = this.items[2].getValue()[0] as IndicatorData;
    return Number(genericQuantityIndicatorData.getValue());
  }

  getSimilarPercentage(): number {
    const genericPercentageIndicatorData = this.items[2].getValue()[1] as IndicatorData;
    return Number(genericPercentageIndicatorData.getValue());
  }
}
